// Curated static vehicle data for Maison Vellore
// All photos: high-resolution editorial photography from Unsplash / Pexels
// Format: price is numeric (EUR), price_formatted is display-ready

export const vehicles = [
  {
    id: "1",
    slug: "ferrari-sf90-spider",
    brand: "Ferrari",
    model: "SF90 Spider",
    title: "Ferrari SF90 Spider — Assetto Fiorano",
    year_iso: "2023-05",
    year_display: "05/2023",
    mileage_km: 4500,
    mileage_display: "4.500 km",
    power_kw: 735,
    power_pk: 1000,
    top_speed: 340,
    acceleration: 2.5,
    price: 514995,
    price_formatted: "€ 514.995,-",
    image: "https://images.unsplash.com/photo-1696581081881-c3d57934f4be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxmZXJyYXJpJTIwcmVkJTIwc3BvcnRzJTIwY2FyfGVufDB8fHx8MTc3ODA1MzYwMnww&ixlib=rb-4.1.0&q=85",
    category: "Sportwagen",
    color: "Rosso Corsa",
    fuel: "Hybride",
    transmission: "8-traps DCT",
    description:
      "Een uitzonderlijk geconserveerd exemplaar van Ferrari's hybride vlaggenschip, uitgevoerd in het emblematische Rosso Corsa en voorzien van het kostbare Assetto Fiorano-pakket. Hoogwaardige carbon-interieur-inleg, elektrisch verstelbare sportstoelen in Pelle Nera en de zeldzame titanium uitlaat. Volledige historie, Ferrari Approved.",
    options: [
      "Assetto Fiorano Performance-pakket",
      "Carbon-fiber interieur",
      "Sportuitlaat titanium",
      "Keramische remmen (CCM-R)",
      "Premium High-Power audio (JBL)",
      "Elektrisch wegklapbare hardtop",
    ],
  },
  {
    id: "2",
    slug: "porsche-911-992-targa-4-gts",
    brand: "Porsche",
    model: "911 992 Targa 4 GTS",
    title: "Porsche 911 (992) Targa 4 GTS",
    year_iso: "2022-10",
    year_display: "10/2022",
    mileage_km: 12000,
    mileage_display: "12.000 km",
    power_kw: 353,
    power_pk: 480,
    top_speed: 307,
    acceleration: 3.5,
    price: 214995,
    price_formatted: "€ 214.995,-",
    image: "https://images.unsplash.com/photo-1699325635304-a2f409b06d19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxwb3JzY2hlJTIwOTExJTIwZ3JleXxlbnwwfHx8fDE3NzgwNTM2MDJ8MA&ixlib=rb-4.1.0&q=85",
    category: "Sportwagen",
    color: "Achatgrau Metallic",
    fuel: "Benzine",
    transmission: "8-traps PDK",
    description:
      "Een kenmerkend exemplaar van de Targa 4 GTS — de meest rijdersgerichte Targa in de 992-reeks. Volledige Porsche-historie, Sport Chrono, lift-systeem en het GTS-interieur in Race-Tex. Een stuk erfgoed, klaar voor zomerritten langs de Riviera.",
    options: [
      "Sport Chrono Pakket",
      "PDCC actief onderstel",
      "Liftsysteem vooras",
      "Race-Tex interieur",
      "Bose Surround Sound",
      "Matrix LED-koplampen",
    ],
  },
  {
    id: "3",
    slug: "aston-martin-vanquish-v12",
    brand: "Aston Martin",
    model: "Vanquish V12",
    title: "Aston Martin Vanquish V12 Coupé",
    year_iso: "2018-06",
    year_display: "06/2018",
    mileage_km: 38000,
    mileage_display: "38.000 km",
    power_kw: 444,
    power_pk: 603,
    top_speed: 324,
    acceleration: 3.5,
    price: 189950,
    price_formatted: "€ 189.950,-",
    image: "https://images.unsplash.com/photo-1743889291767-91037322b6c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxhc3RvbiUyMG1hcnRpbiUyMGNhcnxlbnwwfHx8fDE3NzgwNTM2MDh8MA&ixlib=rb-4.1.0&q=85",
    category: "GT",
    color: "Magnetic Silver",
    fuel: "Benzine",
    transmission: "8-traps automaat",
    description:
      "Een van de laatste, echte atmosferische V12 grand tourers uit Gaydon. Handmatig ingelegde tweedekleurige leren bekleding, walnoot-fineer en volledige Aston Martin onderhoudshistorie. Een sculptuur voor de kenner die waarde hecht aan detail en geluid.",
    options: [
      "Aston Martin Premium Audio (1000W)",
      "Carbon-fiber details",
      "Bang & Olufsen",
      "Sport Plus-stoelen",
      "Keramische remmen",
    ],
  },
  {
    id: "4",
    slug: "range-rover-sport-svr",
    brand: "Range Rover",
    model: "Sport SVR",
    title: "Range Rover Sport SVR",
    year_iso: "2021-03",
    year_display: "03/2021",
    mileage_km: 55000,
    mileage_display: "55.000 km",
    power_kw: 423,
    power_pk: 575,
    top_speed: 283,
    acceleration: 4.5,
    price: 144500,
    price_formatted: "€ 144.500,-",
    image: "https://images.unsplash.com/photo-1740695600568-a7e54e7d3614?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxyYW5nZSUyMHJvdmVyJTIwc3V2JTIwZGFya3xlbnwwfHx8fDE3NzgwNTM2MDh8MA&ixlib=rb-4.1.0&q=85",
    category: "SUV",
    color: "Santorini Black",
    fuel: "Benzine (Supercharged V8)",
    transmission: "8-traps automaat",
    description:
      "Een geraffineerde SVR in de meest smaakvolle kleurcombinatie: Santorini Black met Ebony/Ebony-interieur. Carbon-dakkappen, ventilatiestoelen en het rauwe maar onmiskenbare geluid van de 5.0 liter V8. Een onderhouden exemplaar, geleverd met volledige dealerhistorie.",
    options: [
      "SVR Carbon-pakket",
      "Panoramisch schuifdak",
      "Head-Up Display",
      "Meridian Signature Audio",
      "Ventilerende sportstoelen",
    ],
  },
  {
    id: "5",
    slug: "lamborghini-urus-s",
    brand: "Lamborghini",
    model: "Urus S",
    title: "Lamborghini Urus S",
    year_iso: "2023-01",
    year_display: "01/2023",
    mileage_km: 8000,
    mileage_display: "8.000 km",
    power_kw: 490,
    power_pk: 666,
    top_speed: 305,
    acceleration: 3.5,
    price: 389000,
    price_formatted: "€ 389.000,-",
    image: "https://images.unsplash.com/photo-1708402087099-06b66c99994d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxsYW1ib3JnaGluaSUyMHVydXMlMjB5ZWxsb3d8ZW58MHx8fHwxNzc4MDUzNjA4fDA&ixlib=rb-4.1.0&q=85",
    category: "SUV",
    color: "Giallo Auge",
    fuel: "Benzine (V8 Biturbo)",
    transmission: "8-traps automaat",
    description:
      "De Urus S in de emblematische Giallo Auge. Volledig Ad Personam gespecificeerd, met het hoogwaardige Comfort-Seat-pakket, Bang & Olufsen 3D Sound en de fraai uitgevoerde carbon-afwerkingen. Minimale kilometerstand en onberispelijke staat.",
    options: [
      "Ad Personam kleurstelling",
      "Carbon exterior pakket",
      "Panoramisch schuifdak",
      "Bang & Olufsen 3D Sound",
      "Off-Road modus",
      "Rear-seat entertainment",
    ],
  },
  {
    id: "6",
    slug: "bentley-continental-gt",
    brand: "Bentley",
    model: "Continental GT",
    title: "Bentley Continental GT W12 First Edition",
    year_iso: "2020-11",
    year_display: "11/2020",
    mileage_km: 24000,
    mileage_display: "24.000 km",
    power_kw: 467,
    power_pk: 635,
    top_speed: 333,
    acceleration: 3.7,
    price: 239500,
    price_formatted: "€ 239.500,-",
    image: "https://images.pexels.com/photos/6872600/pexels-photo-6872600.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "GT",
    color: "Dark Sapphire",
    fuel: "Benzine (W12)",
    transmission: "8-traps Dual-Clutch",
    description:
      "De Continental GT in de zeldzame First Edition-uitvoering, uitgevoerd in het klassieke Dark Sapphire. Mulliner-driver specification, diamant-gesneden velgen en handgemaakte leren bekleding in Beluga. Een grand tourer van het allerhoogste niveau.",
    options: [
      "Mulliner Driving Specification",
      "Naim for Bentley Premium Audio",
      "Bentley Rotating Display",
      "Comfort seats met massage",
      "City Assistance-pakket",
    ],
  },
  {
    id: "7",
    slug: "bmw-m5-competition",
    brand: "BMW",
    model: "M5 Competition",
    title: "BMW M5 Competition xDrive",
    year_iso: "2022-07",
    year_display: "07/2022",
    mileage_km: 18000,
    mileage_display: "18.000 km",
    power_kw: 460,
    power_pk: 625,
    top_speed: 305,
    acceleration: 3.3,
    price: 159900,
    price_formatted: "€ 159.900,-",
    image: "https://images.unsplash.com/photo-1563969105338-abc74a72e7e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxibXclMjBtNSUyMGRhcmt8ZW58MHx8fHwxNzc4MDUzNjE1fDA&ixlib=rb-4.1.0&q=85",
    category: "Sportsedan",
    color: "Saphirschwarz",
    fuel: "Benzine (V8 BiTurbo)",
    transmission: "8-traps M Steptronic",
    description:
      "Een volledig uitgeruste M5 Competition in Saphirschwarz, met M Driver's Package, M Carbon-keramische remmen en het Bowers & Wilkins Diamond audiosysteem. Een eerste eigenaar, volledige onderhoudshistorie via de officiële importeur.",
    options: [
      "M Driver's Package",
      "M Carbon Keramisch remsysteem",
      "Bowers & Wilkins Diamond",
      "M Carbon bucket-stoelen",
      "Schuif-kanteldak",
      "Laserlight",
    ],
  },
  {
    id: "8",
    slug: "audi-rs6-avant",
    brand: "Audi",
    model: "RS6 Avant",
    title: "Audi RS6 Avant Performance",
    year_iso: "2021-09",
    year_display: "09/2021",
    mileage_km: 31000,
    mileage_display: "31.000 km",
    power_kw: 441,
    power_pk: 600,
    top_speed: 305,
    acceleration: 3.6,
    price: 164950,
    price_formatted: "€ 164.950,-",
    image: "https://images.unsplash.com/photo-1713174016723-13be613ed765?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxhdWRpJTIwcnM2JTIwYXZhbnQlMjBkYXJrfGVufDB8fHx8MTc3ODA1MzYxNXww&ixlib=rb-4.1.0&q=85",
    category: "Estate",
    color: "Nardograu",
    fuel: "Benzine (Mild-Hybrid V8)",
    transmission: "8-traps Tiptronic",
    description:
      "De iconische RS6 Avant Performance in Nardograu — de enige sportieve estate die zakelijke elegantie en absolute prestaties verenigt. Dynamic Plus-pakket, keramische remmen en RS Design Pakket Plus in rood. Beschikbaar voor directe aflevering.",
    options: [
      "RS Dynamic Plus-pakket",
      "Keramische remmen",
      "RS Design Pakket Plus Rood",
      "B&O Advanced 3D Sound",
      "Matrix HD LED",
      "Panoramadak",
    ],
  },
];

export const brandOptions = [
  "Alle merken",
  ...Array.from(new Set(vehicles.map((v) => v.brand))).sort(),
];

export const priceCeilings = [
  { value: "any", label: "Elke prijs" },
  { value: "150000", label: "Tot € 150.000" },
  { value: "200000", label: "Tot € 200.000" },
  { value: "250000", label: "Tot € 250.000" },
  { value: "400000", label: "Tot € 400.000" },
  { value: "600000", label: "Tot € 600.000" },
];

export const sortOptions = [
  { value: "newest", label: "Nieuwste eerst" },
  { value: "price_desc", label: "Prijs — hoog naar laag" },
  { value: "price_asc", label: "Prijs — laag naar hoog" },
  { value: "az", label: "A — Z" },
  { value: "za", label: "Z — A" },
];
